import "./SectionFooter.scss";

import React from "react";

import {
  FeatureToggle,
  SectionFooterData
} from "../../models/app-data-model";
import FooterQuickLinks from "../footer-quick-links/FooterQuickLinks";
import RichTextBlock from "../rich-text-block/RichTextBlock";

export type SectionFooterProps = {
  sectionFooter: SectionFooterData;
  featureToggles: FeatureToggle[];
};

const SectionFooter: React.FC<SectionFooterProps> = ({ sectionFooter }) => {
  const quickLinksColumn = sectionFooter?.footer_navigation_group?.quick_link_column;

  const quickLinks = quickLinksColumn && quickLinksColumn.map((columnData, index) => <FooterQuickLinks quickLinkColumn={columnData} key={index} />);

  const richText = sectionFooter?.footer_rtf && <RichTextBlock content={sectionFooter.footer_rtf} />;

  return (
    <div className='section-footer'>
      <footer className='section-footer-content'>
        {quickLinks && <div className='quicklinks-columns'>
          {quickLinks}
        </div>}
        {richText && <div className='rtf'>
          {richText}
        </div>}
        </footer>
    </div>
  );
};

export default SectionFooter;
